import http from 'services/http'
import { sleep } from '@/utils'
import $ from 'jquery'

export class Form {
  constructor({ fields, url, onError, onSuccess, delay, useAuthToken = true }) {
    this.url = url
    this.fields = fields
    this.data = this.getInitialData(fields)
    this.errors = this.getDefaultErrors()
    this.submitInProgress = false
    this.submitSucceeded = false
    this.delay = delay || 0
    this.useAuthToken = useAuthToken

    if (onError) {
      this.onError = onError
    }
    if (onSuccess) {
      this.onSuccess = onSuccess
    }
  }

  setUrl(url) {
    this.url = url
  }

  getInitialData(fields) {
    const data = {}
    fields.forEach((field) => {
      data[field.name] = field.default !== undefined ? field.default : ''
    })
    return data
  }

  clean() {
    this.data = this.getInitialData(this.fields)
  }

  hasErrors(name) {
    return this.errors[name] && this.errors[name].length > 0
  }

  getDefaultErrors() {
    const errors = {}
    this.fields.forEach((field) => {
      errors[field.name] = []
    })
    return errors
  }

  async submit(opts) {
    opts = opts || {}
    const extraData = opts.extraData || {}
    const self = this
    self.errors = self.getDefaultErrors() // reset errors
    self.submitInProgress = true

    try {
      const request = this.postForm({ extraData })
      await sleep(self.delay)
      const response = await request
      self.onSuccess({ response })
      self.submitSucceeded = true
    } catch (error) {
      if (!error.response) {
        throw error
      }
      self.errors = error.response.data
      self.onError({ error })
      self.submitSucceeded = false
    }
    self.submitInProgress = false
  }

  postForm({ extraData = {} }) {
    const data = this.getFormData({ extraData })
    if (this.useAuthToken) {
      return http.postAuthed(this.url, data)
    } else {
      return http.post(this.url, data)
    }
  }

  getFormData({ extraData = {} }) {
    return Object.assign({}, this.data, extraData)
  }

  onError({ error }) {}
  onSuccess({ response }) {}
}

export function htmlToText(html) {
  const parsed = $.parseHTML(html || '')
  return $.text(parsed)
}
